import { Component } from "react";

// Pantalla de recuperación: evita la "pantalla en blanco" ante cualquier error de JavaScript.
export default class ErrorBoundary extends Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) {
    try {
      const log = JSON.parse(localStorage.getItem("app_error_log") || "[]");
      log.unshift({ at: new Date().toISOString(), msg: String(error?.message || error), stack: (info?.componentStack || "").slice(0, 800), url: window.location.pathname });
      localStorage.setItem("app_error_log", JSON.stringify(log.slice(0, 10)));
    } catch { /* noop */ }
    // Bundle viejo tras una actualización: recargar una sola vez
    if (/ChunkLoadError|Loading chunk|Failed to fetch dynamically imported module/i.test(String(error?.message || error)) && !sessionStorage.getItem("chunk_reloaded")) {
      sessionStorage.setItem("chunk_reloaded", "1");
      window.location.reload();
    }
  }
  reset = () => { this.setState({ error: null }); };
  hardReload = async () => {
    try {
      if ("serviceWorker" in navigator) { const regs = await navigator.serviceWorker.getRegistrations(); await Promise.all(regs.map((r) => r.unregister())); }
      if ("caches" in window) { const keys = await caches.keys(); await Promise.all(keys.map((k) => caches.delete(k))); }
    } catch { /* noop */ }
    window.location.reload();
  };
  cleanLocal = () => {
    if (!window.confirm("Se borrarán los datos temporales de este equipo (caché de productos y preferencias). NO se borran ventas pendientes ni la vinculación de la terminal. ¿Continuar?")) return;
    try {
      const keep = ["token", "device_uid", "pos_station_id", "off_sales_queue", "off_sales_seq", "scale_linked"];
      Object.keys(localStorage).forEach((k) => { if (!keep.includes(k)) localStorage.removeItem(k); });
    } catch { /* noop */ }
    this.hardReload();
  };
  render() {
    if (!this.state.error) return this.props.children;
    const msg = String(this.state.error?.message || this.state.error);
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0b1220] p-6" data-testid="error-boundary">
        <div className="max-w-md w-full rounded-2xl bg-white p-6 shadow-2xl space-y-4">
          <img src="/profesionalpos-logo.png" alt="ProfesionalPOS" className="h-10 w-auto" />
          <div>
            <h1 className="font-display font-bold text-xl text-slate-900">Algo salió mal en esta pantalla</h1>
            <p className="text-sm text-slate-600 mt-1">El sistema se protegió para no dejarte en blanco. Puedes reintentar o recargar; tus ventas pendientes y la terminal se conservan.</p>
          </div>
          <pre className="text-[11px] bg-slate-100 rounded-lg p-2 overflow-auto max-h-24 text-slate-700 whitespace-pre-wrap">{msg}</pre>
          <div className="grid grid-cols-2 gap-2">
            <button onClick={this.reset} className="h-10 rounded-lg border border-slate-300 font-semibold text-sm hover:bg-slate-50" data-testid="eb-retry">Reintentar</button>
            <button onClick={() => window.location.reload()} className="h-10 rounded-lg bg-emerald-500 text-white font-bold text-sm hover:bg-emerald-600" data-testid="eb-reload">Recargar</button>
            <button onClick={this.hardReload} className="h-10 rounded-lg border border-slate-300 font-semibold text-sm hover:bg-slate-50" data-testid="eb-hard">Actualizar versión</button>
            <button onClick={this.cleanLocal} className="h-10 rounded-lg border border-red-200 text-red-600 font-semibold text-sm hover:bg-red-50" data-testid="eb-clean">Limpiar datos temporales</button>
          </div>
          <a href="/pos" className="block text-center text-xs text-slate-500 underline">Ir al Punto de Venta</a>
        </div>
      </div>
    );
  }
}
